import { styled } from 'goober';
import { forwardRef } from 'react';
import { ThemeColorKeys } from '../../base/useTheme';

interface SwitchProps {
    $color?: ThemeColorKeys;
    $checked?: boolean;
    $disabled?: boolean;
}

export const SwitchThumb = styled('span')`
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: white;
    transition: transform 0.2s ease-in-out;
`;

export const SwitchTrack = styled('div')<SwitchProps>(
    ({ theme, $checked = false, $disabled = false, $color = 'primary' }) => {
        const disabledColor = theme.colors.neutral.w700;
        return {
            position: 'relative',
            margin: '0px',
            width: '22px',
            height: '14px',
            display: 'flex',
            alignItems: 'center',
            padding: '3px',
            borderRadius: '100px',
            cursor: $disabled ? 'not-allowed' : 'pointer',
            userSelect: 'none',
            transition: 'background-color 0.2s ease-in-out',

            backgroundColor: $checked
                ? $disabled
                    ? disabledColor
                    : theme.colors[$color].w500
                : theme.colors.neutral.w300,

            '&:hover': $disabled
                ? undefined
                : {
                      backgroundColor: $checked ? theme.colors[$color].w700 : theme.colors.neutral.w400,
                  },

            '& > span': {
                backgroundColor: $disabled && !$checked ? theme.colors.neutral.w600 : theme.colors.ui.white,
                transform: $checked ? 'translateX(8px)' : 'translateX(0px)',
            },
        };
    }
);

export const SwitchInput = styled('input', forwardRef)`
    border: 0;
    clip: rect(0 0 0 0);
    overflow: hidden;
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    right: 0px;
`;
